import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { ActiveCartFacade } from '@spartacus/cart/base/root';
import { CheckoutConfigService, CheckoutStepService, ExpressCheckoutService } from '@spartacus/checkout/base/components';
import { CheckoutStepType } from '@spartacus/checkout/base/root';
import { RoutingConfigService } from '@spartacus/core';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CustomCheckoutGuard  {
  private readonly firstStep$: Observable<UrlTree>;

  constructor(
    protected router: Router,
    protected routingConfigService: RoutingConfigService,
    protected checkoutConfigService: CheckoutConfigService,
    protected expressCheckoutService: ExpressCheckoutService,
    protected activeCartService: ActiveCartFacade,
    protected checkoutStepService: CheckoutStepService
  ) {
    this.firstStep$ = of(
      this.router.parseUrl(
        this.routingConfigService.getRouteConfig(
          this.checkoutStepService.getFirstCheckoutStepRoute()
        )?.paths?.[0] as string
      )
    );
  }

  canActivate(): Observable<boolean | UrlTree> {
    if (
      this.checkoutConfigService.isExpressCheckout() &&
      !this.activeCartService.isGuestCart()
    ) {
      return this.expressCheckoutService.trySetDefaultCheckoutDetails().pipe(
        switchMap((expressCheckoutPossible: boolean) => {
          const reviewOrderRoute =
            this.checkoutStepService.getCheckoutStepRoute(
              CheckoutStepType.DELIVERY_ADDRESS
            );
          return expressCheckoutPossible && reviewOrderRoute
            ? of(
              this.router.parseUrl(
                this.routingConfigService.getRouteConfig(reviewOrderRoute)
                  .paths?.[0] as string
              )
            )
            : this.firstStep$;
        })
      );
    }
    return this.firstStep$;
  }
}
